import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, NgForm, Validators, FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { SellerService } from "src/app/core/services/seller.service";
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
import { FetchDataService } from 'src/app/core/services/fetch-data.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  constructor(private router: Router,private modalService: NgbModal,private viewportScroller: ViewportScroller) { }

  user;
  type;
  extra = true;
     faqs = [
    {
      question: 'What is Connekkt Xchange ?',
      answer: 'Connekkt.media is a digital media agency specializing ...',
      open: false
    },
    {
      question: 'What services do you offer ?',
      answer: 'We offer a range of services including...',
      open: false
    }
  ];

  ngOnInit(): void {

    this.user = JSON.parse(localStorage.getItem('clpUser'));
    if (localStorage.getItem("clpUser") != null) {
      // alert("11")
      this.extra = false;

    }  }
  gotoScroll(itemId:string){
    this.viewportScroller.scrollToAnchor(itemId);
  }
  /**
   * Open small modal
   * @param largeDataModal small modal data
   */
goToVideo() {
this.router.navigate(['/howItWorks'], {
fragment: 'video-section'
});
}
  smallModal(largeDataModal: any) {
    this.modalService.open(largeDataModal, { size: 'lg', centered: true });
  }
  logout() {

    // this.router.navigate(['/account/login']);
    localStorage.clear();
     this.router.navigate(['/account/login']).then(() => {
    window.location.reload();
  });
  }
    toggle(i: number) {
    this.faqs[i].open = !this.faqs[i].open;
  }
  dashboard() {
    this.user = JSON.parse(localStorage.getItem('clpUser')).type
    if (this.user == 1) {
      this.router.navigate(['/buyer/marketplace']);
    } else {
      this.router.navigate(['/seller/contentlist']);
    }

  }
}
